// API Configuration
export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7103/api',
  timeout: 10000, // 10 seconds
  retryAttempts: 3,
  version: process.env.REACT_APP_VERSION || '1.0.0',
} as const;

// Helper function to get the base URL
export const getApiBaseUrl = (): string => {
  return API_CONFIG.baseUrl;
};

// Server origin without the trailing /api — SignalR hubs live at /hubs/*, not under /api
export const getApiOrigin = (): string => {
  return API_CONFIG.baseUrl.replace(/\/api\/?$/, '');
};

// Environment-specific configurations
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
export const isProduction = process.env.NODE_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';

// Feature flags
export const DEBUG_MODE = process.env.REACT_APP_ENABLE_DEBUG_MODE === 'true';
export const ANALYTICS_ENABLED = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';

// Application info
export const getAppVersion = (): string => API_CONFIG.version;